import React from 'react'
import './styles.scss'
import Technews from '../../assets/News presenter.svg'
import Community from '../../assets/community.svg'
import Freelance from '../../assets/webDev.svg'
import { Link, withRouter } from 'react-router-dom'
import { Container, Row, Image, Button } from 'react-bootstrap'
import { signInWithGoogle } from '../../firebase/firebase-utils'

function Services(props) {

    const RouteCommunity = () => {
        if (props.user != null) {
            window.scrollTo({ top: 0 })
            props.history.push('/community');
        } else {
            window.scrollTo({ top: 0 })
            signInWithGoogle();
            props.history.push('/community');
        }
    }

    const RouteFreelance = () => {
        window.scrollTo({ top: 0 });
        props.history.push('/freelance');
    }
    return (
        <div id="Services">
            <Row>
                <Container>
                    <h1 className="Title" style={{ color: '#fff' }}>Services</h1>
                    <br />
                    <div className="Services-cards">
                        <Link to="/technews"><div className="ServiceCard">
                            <Image className="Image" src={Technews} fluid />
                            <Button className="button">Technews</Button>
                        </div></Link>
                        <div className="ServiceCard" onClick={RouteCommunity}>
                            <Image className="Image" src={Community} fluid />
                            <Button className="button">Community Media</Button>
                        </div>
                        <div className="ServiceCard" onClick={RouteFreelance}>
                            <Image className="Image" src={Freelance} fluid />
                            <Button className="button">Freelance</Button>
                        </div>
                    </div>
                </Container>
            </Row>
        </div >
    )
}

export default withRouter(Services)
